import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface MinimalToolOption {
  id: string;
  name: string;
}

interface TemplateAdditionalSettingsProps {
  tools?: MinimalToolOption[];
  toolId: string;
  onToolChange: (v: string) => void;
  estimatedMinutes: string;
  onEstimatedMinutesChange: (v: string) => void;
  targetAudience: string;
  onTargetAudienceChange: (v: string) => void;
  isFeatured: boolean;
  onFeaturedChange: (checked: boolean) => void;
}

export const TemplateAdditionalSettings = ({
  tools,
  toolId,
  onToolChange,
  estimatedMinutes,
  onEstimatedMinutesChange,
  targetAudience,
  onTargetAudienceChange,
  isFeatured,
  onFeaturedChange,
}: TemplateAdditionalSettingsProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-foreground">Additional Settings</h3>
      <div className="grid grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="tool_id">Associated Tool</Label>
          <Select value={toolId} onValueChange={onToolChange}>
            <SelectTrigger>
              <SelectValue placeholder="Select tool" />
            </SelectTrigger>
            <SelectContent>
              {tools?.map((tool) => (
                <SelectItem key={tool.id} value={tool.id}>
                  {tool.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="estimated_duration_minutes">Duration (minutes)</Label>
          <Input
            id="estimated_duration_minutes"
            type="number"
            value={estimatedMinutes}
            onChange={(e) => onEstimatedMinutesChange(e.target.value)}
            placeholder="e.g., 15"
            min="1"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="target_audience">Target Audience</Label>
        <Input
          id="target_audience"
          value={targetAudience}
          onChange={(e) => onTargetAudienceChange(e.target.value)}
          placeholder="e.g., Direct Reports & Peers"
        />
      </div>

      <div className="flex items-center space-x-3 p-3 border rounded-md bg-muted/20">
        <Switch
          id="is_featured"
          checked={isFeatured}
          onCheckedChange={onFeaturedChange}
        />
        <Label htmlFor="is_featured" className="text-sm font-medium">
          Featured Template
        </Label>
      </div>
    </div>
  );
};

export default TemplateAdditionalSettings;

